/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateSASToken201Response
 */
export interface GenerateSASToken201Response {
    /**
     * Pre-signed URL for direct upload
     * @type {string}
     * @memberof GenerateSASToken201Response
     */
    uploadUrl?: string;
    /**
     * Unique blob name in Azure Storage
     * @type {string}
     * @memberof GenerateSASToken201Response
     */
    blobName?: string;
    /**
     * Azure Storage container name
     * @type {string}
     * @memberof GenerateSASToken201Response
     */
    containerName?: string;
    /**
     * Token expiration time
     * @type {Date}
     * @memberof GenerateSASToken201Response
     */
    expiresAt?: Date;
}

/**
 * Check if a given object implements the GenerateSASToken201Response interface.
 */
export function instanceOfGenerateSASToken201Response(value: object): value is GenerateSASToken201Response {
    return true;
}

export function GenerateSASToken201ResponseFromJSON(json: any): GenerateSASToken201Response {
    return GenerateSASToken201ResponseFromJSONTyped(json, false);
}

export function GenerateSASToken201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateSASToken201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadUrl': json['uploadUrl'] == null ? undefined : json['uploadUrl'],
        'blobName': json['blobName'] == null ? undefined : json['blobName'],
        'containerName': json['containerName'] == null ? undefined : json['containerName'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

  export function GenerateSASToken201ResponseToJSON(json: any): GenerateSASToken201Response {
      return GenerateSASToken201ResponseToJSONTyped(json, false);
  }

  export function GenerateSASToken201ResponseToJSONTyped(value?: GenerateSASToken201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadUrl': value['uploadUrl'],
        'blobName': value['blobName'],
        'containerName': value['containerName'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
    };
}

